module.exports = __webpack_public_path__ + "static/media/soundfalse.02ecbbab.mp3";